// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BmTN","top":"styles_top__3jiua","left":"styles_left__1pXAf","description":"styles_description__3kZMf"};